import {
  Button,
  FormInput,
  FormNumber,
  FormRoot,
  FormTextarea,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import type {
  CreateAuditTypeDTO,
  UpdateAuditTypeDTO,
} from "../../domain/contracts/type";

const AuditTypeFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາປ້ອນຊື່ປະເພດ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().default(0),
});

export type AuditTypeFormValues = z.infer<typeof AuditTypeFormSchema>;

export function AuditTypeForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<AuditTypeFormValues>;
  onSubmit: (values: CreateAuditTypeDTO | UpdateAuditTypeDTO) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<AuditTypeFormValues>({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver type inference issue
    resolver: zodResolver(AuditTypeFormSchema) as any,
    defaultValues: {
      name: "",
      description: null,
      orderIndex: 0,
      ...initialValues,
    },
  });

  return (
    <FormRoot<AuditTypeFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          name: vals.name,
          description: vals.description ?? null,
          orderIndex: vals.orderIndex ?? 0,
        })
      }
      className="space-y-4"
    >
      <FormInput
        name="name"
        label="ຊື່ປະເພດ"
        requiredMark
        placeholder="ຕົວຢ່າງ: SOP, QC, ງານຂາຍ"
      />
      <FormTextarea
        name="description"
        label="ຄຳອະທິບາຍ"
        placeholder="ຄຳອະທິບາຍປະເພດການກວດສອບ"
        rows={3}
      />
      <FormNumber
        name="orderIndex"
        label="ລໍາດັບ"
        placeholder="0"
        hint="ລໍາດັບສໍາລັບການຈັດລຽງ (ຕໍ່່າກ = ສະແດງກ່ອນ)"
      />
      <div className="flex justify-end gap-2">
        <Button
          type="button"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={submitting}
          isLoading={submitting}
        >
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}

